<template>
    <div
        class="modal fade"
        role="dialog"
        aria-modal="true"
        :class="modalClass"
        :id="id"
        tabindex="-1"
        :aria-labelledby="labelledBy || undefined"
        :aria-label="labelledBy ? undefined : label"
        :data-bs-backdrop="staticBackdrop ? 'static' : undefined"
        :data-bs-keyboard="keyboard ? undefined : 'false'"
        aria-hidden="true"
    >
        <div :id="resolvedDialogId" class="modal-dialog modal-dialog-centered" :class="dialogClass">
            <div class="modal-content text-bg-light" :class="contentClass">
                <div v-if="$slots.header" class="modal-header" :class="headerClass">
                    <slot name="header" />
                </div>
                <div class="modal-body" :class="bodyClass">
                    <slot />
                </div>
                <div v-if="$slots.footer" class="modal-footer" :class="footerClass">
                    <slot name="footer" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'BaseModal',
    props: {
        id: {
            type: String,
            required: true
        },
        labelledBy: {
            type: String,
            default: ''
        },
        dialogId: {
            type: String,
            default: ''
        },
        dialogClass: {
            type: [String, Array, Object],
            default: ''
        },
        contentClass: {
            type: [String, Array, Object],
            default: ''
        },
        modalClass: {
            type: [String, Array, Object],
            default: ''
        },
        headerClass: {
            type: [String, Array, Object],
            default: ''
        },
        bodyClass: {
            type: [String, Array, Object],
            default: ''
        },
        footerClass: {
            type: [String, Array, Object],
            default: ''
        },
        staticBackdrop: {
            type: Boolean,
            default: false
        },
        keyboard: {
            type: Boolean,
            default: true
        },
        label: {
            type: String,
            default: 'Dialog'
        }
    },
    mounted() {
        this.previousFocusedElement = null
        this.modalElement = this.$el
        this.modalElement.addEventListener('show.bs.modal', this.rememberFocus)
        this.modalElement.addEventListener('shown.bs.modal', this.focusFirstControl)
        this.modalElement.addEventListener('hidden.bs.modal', this.restoreFocus)
    },
    beforeUnmount() {
        this.modalElement?.removeEventListener('show.bs.modal', this.rememberFocus)
        this.modalElement?.removeEventListener('shown.bs.modal', this.focusFirstControl)
        this.modalElement?.removeEventListener('hidden.bs.modal', this.restoreFocus)
    },
    methods: {
        rememberFocus() {
            this.previousFocusedElement = document.activeElement
        },
        focusFirstControl() {
            const control = this.$el.querySelector('button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])')
            control?.focus()
        },
        restoreFocus() {
            if (this.previousFocusedElement && document.contains(this.previousFocusedElement)) {
                this.previousFocusedElement.focus()
            }
        }
    },
    computed: {
        resolvedDialogId() {
            return this.dialogId || this.id + 'Dialog'
        }
    }
}
</script>
